module.exports = __webpack_public_path__ + "img/dropFace.1424b05a.svg";